import {menu} from "../../utils/api";
import router from "../../router";

export default {
  state: {
    //属性
    isLogin: false,
    isReady: false,
    activeUrl: '1',
    menuList: [],
  },
  getters: {
    isLogin: state => state.isLogin,
    isReady: state => state.isReady,
    activeUrl: state => state.activeUrl,
    menuList: state => state.menuList,
    isVisible: state=>{
      return (val)=>{
        let isShow = false;
        if(state.menuList){
          for(let i=0;i<state.menuList.length;i++){
            if(state.menuList[i].sign == val){
              isShow = state.menuList[i].visible == 1;
              break;
            }
          }
        }
        return isShow
      }
    }
  },
  mutations: {
    //set方法
    setLogin(state, val) {
      state.isLogin = val
    },
    setReady(state, val) {
      state.isReady = val
    },
    setMenuList(state, val) {
      state.menuList = val
    },
    setActiveUrl(state, val) {
      state.activeUrl = val
    }
  },
  actions: {
    async initMenu({commit}) {
      return new Promise((resolve, reject) => {
        menu.mine().then(res => {
          if (res) {
            commit('setReady', true)
            commit('setMenuList', res.data)
            resolve(res.data);
          }
        }).catch(error => {
          console.log("查询菜单失败")
          reject(error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/module.js